module.exports = __webpack_public_path__ + "img/Bold 2px-building.0cf8a6da.svg";